import { clsx } from 'clsx';

import type ILoader from './interfaces/ILoader';

import styles from './sass/Loader.module.scss';

export default function Loader({
  isPageLoading, className, fullLoaderClassName, classNameLoader, isFullLoader = true,
}: ILoader) {
  return (
    <div className={clsx(styles.root, {
      [styles.isPageLoading]: isPageLoading,
      className,
    })}
    >
      {isFullLoader ? <div className={clsx(styles.fullLoader, fullLoaderClassName)} /> : null }
      <div className={clsx(styles.loader, classNameLoader)} />
    </div>
  );
}
